export default __webpack_public_path__ + "static/media/endorser.1e82327f.png";